export enum NotificationDeliveryType {
    IMMEDIATE = 'IMMEDIATE',
    SCHEDULED = 'SCHEDULED',
    RECURRING = 'RECURRING',
}
